// extracted by mini-css-extract-plugin
module.exports = {"list":"IndexList_list__ucp9W","item":"IndexList_item__2cMBN"};